import { SpecialInstructionsSection } from "~/features/quote/components/shipment-details/components/additional-details-section/special-instructions-section.tsx";

import tenderLtlStyles from "../../index.module.css";
import styles from "./tender-special-instructions.module.css";

type TenderSpecialInstructionsProps = {
	hideSaveInstructions?: boolean;
};

export const TenderSpecialInstructions = ({
	hideSaveInstructions = false,
}: TenderSpecialInstructionsProps = {}) => {
	return (
		<div
			className={`${styles.tenderSpecialInstructionsWrapper} ${tenderLtlStyles.tenderLtlCard}`}
		>
			<h4>Special Instructions</h4>
			<SpecialInstructionsSection hideSaveInstructions={hideSaveInstructions} />
		</div>
	);
};
